// ================================================================
// Sidebar
// ================================================================

import './sidebar.css';
import { t } from '../../i18n/index.js';
import { icon } from '../../utils/dom.js';
import { events, EVENTS } from '../../core/events.js';
import { getUser } from '../../core/auth.js';
import { openPlatformPanel } from '../platform/PlatformPanel.js';
import { openAssistantChatsPanel } from '../platform/AssistantChatsPanel.js';
import { openAiUsagePanel } from '../platform/AiUsagePanel.js';
import { openOrgPanel } from '../org/OrgPanel.js';
import { openPromptsPanel } from '../prompts/PromptsPanel.js';
import { openCredentialsPanel } from '../credentials/CredentialsPanel.js';

const NAV_ITEMS = [
  { key: 'org',         labelKey: 'sidebar.org',         icon: 'apartment' },
  { key: 'scenarios',   labelKey: 'sidebar.scenarios',   icon: 'account_tree',  active: true },
  { key: 'aiAgents',    labelKey: 'sidebar.aiAgents',    icon: 'smart_toy' },
  { key: 'prompts',     labelKey: 'sidebar.prompts',     icon: 'auto_awesome' },
  { key: 'credentials', labelKey: 'sidebar.credentials', icon: 'shield' },
  { key: 'webhooks',    labelKey: 'sidebar.webhooks',    icon: 'webhook' },
  { key: 'templates',   labelKey: 'sidebar.templates',   icon: 'dashboard' }
];

let containerEl = null;

// فقط کاربرِ platform (مثل محمد/LevelUpAi) آیتم‌های «شرکت‌ها» و «گفتگوها» را می‌بیند
function isPlatformUser() {
  const u = getUser();
  const perms = u?.role?.permissions || [];
  return perms.includes('platform:orgs:read') || u?.organization?.isPlatform === true;
}

export function renderSidebar(container) {
  containerEl = container;
  draw();
  events.on(EVENTS.LANGUAGE_CHANGED, draw);
}

function draw() {
  const platformItem = isPlatformUser()
    ? `<button class="sidebar-item sidebar-item-platform" data-key="companies">
         ${icon('corporate_fare', 22)}
         <span>${t('sidebar.companies')}</span>
       </button>
       <button class="sidebar-item sidebar-item-platform" data-key="assistantChats">
         ${icon('forum', 22)}
         <span>${t('sidebar.assistantChats')}</span>
       </button>
       <button class="sidebar-item sidebar-item-platform" data-key="aiUsage">
         ${icon('monitoring', 22)}
         <span>${t('sidebar.aiUsage')}</span>
       </button>`
    : '';

  containerEl.innerHTML = `
    <div class="sidebar-logo">M</div>
    <nav class="sidebar-nav">
      ${platformItem}
      ${NAV_ITEMS.map(item => `
        <button class="sidebar-item ${item.active ? 'active' : ''}" data-key="${item.key}">
          ${icon(item.icon, 22)}
          <span>${t(item.labelKey)}</span>
        </button>
      `).join('')}
    </nav>
  `;

  const companiesBtn = containerEl.querySelector('[data-key="companies"]');
  if (companiesBtn) companiesBtn.addEventListener('click', openPlatformPanel);

  const chatsBtn = containerEl.querySelector('[data-key="assistantChats"]');
  if (chatsBtn) chatsBtn.addEventListener('click', openAssistantChatsPanel);

  const usageBtn = containerEl.querySelector('[data-key="aiUsage"]');
  if (usageBtn) usageBtn.addEventListener('click', openAiUsagePanel);

  const orgBtn = containerEl.querySelector('[data-key="org"]');
  if (orgBtn) orgBtn.addEventListener('click', openOrgPanel);

  const promptsBtn = containerEl.querySelector('[data-key="prompts"]');
  if (promptsBtn) promptsBtn.addEventListener('click', openPromptsPanel);
  const credsBtn = containerEl.querySelector('[data-key="credentials"]');
  if (credsBtn) credsBtn.addEventListener('click', openCredentialsPanel);

  const scenariosBtn = containerEl.querySelector('[data-key="scenarios"]');
  if (scenariosBtn) scenariosBtn.addEventListener('click', () => events.emit(EVENTS.SIDEBAR_COMPANIES_TOGGLE));
}
